import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-scroll-to-top',
  imports: [],
  templateUrl: './scroll-to-top.html',
  styleUrl: './scroll-to-top.css',
})
export class ScrollToTop {
  showButton = true; // Cambiado a true para pruebas

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.showButton = window.scrollY > 100; // Reducido a 100px para aparecer más rápido
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
